import styled from 'styled-components';
import { WhiteButton } from '../../../../baseComponents/button';
import { TypographyStyles, colours, media, spacing } from '../../../../stylings';

export const Button = styled(WhiteButton)`
  align-items: start;
  background: ${colours.WHITE};
  border: 1px solid ${colours.GREY};
  color: ${colours.BLACK};
  display: flex;
  flex-direction: row;
  gap: 10px;
  height: 100%;
  min-width: 111px;
  padding: 7px 20px;
  text-transform: initial;
  ${TypographyStyles.Body.Small.Regular}
  svg {
    height: 10px;
    margin-block-start: ${spacing.XXXS};
    min-height: 10px;
    min-width: 10px;
    width: 10px;

    @media ${media.greaterThan('lg')} {
      margin-block-start: 10px;
    }
  }
  @media ${media.greaterThan('lg')} {
    padding: 9px 20px;
  }
`;
